<div class="mapping-questionnaire-container">
  <div class="questionnaire-content-header">
    <div class="questionnaire-title">
      {{ questionnaireContent.mappingTitle }}
    </div>
    <div class="questionnaire-sub-title">
      {{ questionnaireContent.mappingSubTitle }}
      <u-button [label]="questionnaireContent.learnMore" class="link-button" type="link" (mousedown)="openLearnMore()"></u-button>
    </div>
  </div>
  <div class="questionnaire-file">
    <div class="questionnaire-details-file">
      <u-icon [model]="{ type: 'font', value: 'icon-page' }" class="questionnaire-file-icon"></u-icon>
      <span class="questionnaire-file-name" (auxclick)="openContextMenu($event)" (contextmenu)="openContextMenu($event)">
        {{ questionnaireContent.requestForProposal }} <span class="name">{{ data.fileName }} </span>.{{ data.extension }}
      </span>
    </div>
    <div *ngIf="isChanged" (click)="onReset()" class="questionnaire-action">Reset</div>
  </div>
  <ng-scrollbar class="mapping-questionnaire-content" visibility="hover">
    <div *ngFor="let ws of worksheets; index as i">
      <mapping-worksheet [worksheet]="ws" (changed)="onChange($event, i)"></mapping-worksheet>
    </div>
  </ng-scrollbar>
  <span class="mapping-description">{{ questionnaireContent.mappingDescription }}</span>
  <u-button
    class="run-process"
    *ngIf="worksheets?.length"
    [disabled]="disabledRunProcess"
    [label]="questionnaireContent.runProcess"
    [styles]="{ width: '180px' }"
    [loading]="loadingButton"
    tooltipPosition="top"
    [pTooltip]="disabledRunProcess ? disabledRunProcessTooltip : null"
    tooltipStyleClass="u-tooltip"
    type="primary"
    (mousedown)="onRunProcessClick()"
  ></u-button>
</div>
